import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationInfoService } from '@app/core/guards/authentication-info.service';
import { ImportReportModel } from '@app/core/models/administration/imports/import-report.model';
import { EmailTemplateModel } from '@app/core/models/emails/email-template.model';
import { EmailTemplateService } from '@app/core/services/email-template.service';
import { AdministrationBase } from '@app/features/administration/administration-base';
import { ModalComponent } from '@app/shared/components/modal/modal.component';
import { ModalHelper } from '@app/shared/models/modal-helper.model';
import { TableActionIcon, TableRowAction } from '@app/shared/models/table-action-type.model';
import { Observable, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-email-template-list',
  templateUrl: './email-template-list.component.html',
  styleUrls: ['./email-template-list.component.scss'],
})
export class EmailTemplateListComponent
  extends AdministrationBase<EmailTemplateModel>
  implements OnInit, OnDestroy
{
  constructor(
    route: ActivatedRoute,
    router: Router,
    private emailTemplateService: EmailTemplateService,
    public dialog: MatDialog,
    authenticationInfoService: AuthenticationInfoService,
  ) {
    super(dialog, router, route, authenticationInfoService);
    this.tableActions.push(
      new TableRowAction(TableActionIcon.DELETE, 'Supprimer', this.onDelete)
    );
    this.title = 'TEMPLATES EMAIL';
    this.subtitle = 'template email';
  }

  ngOnInit(): void {}

  protected importHandler(files: File[]): Observable<ImportReportModel[]> {
    throw new Error('Method not used.');
  }

  onDelete = (model: EmailTemplateModel) => {
    const hasOtherOfType =
      this.dataItems.filter((email) => email.TypeId === model.TypeId).length >
      1;
    if (!hasOtherOfType) {
      return this.onDeleteDeny(model.TypeName);
    }

    const confimModal = new ModalHelper().getConfirmationConfig(
      `Êtes-vous sûr de vouloir supprimer ce template email ?`
    );
    const dialogRef = this.dialog.open(ModalComponent, confimModal);
    return dialogRef
      .afterClosed()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isSuccess: boolean) => {
        if (isSuccess) {
          return this.onDeleteConfirm(model.Id);
        }
      });
  };

  onDeleteDeny(typeName: string): Observable<any> {
    const confimModal = new ModalHelper().getAlertConfig(
      `Vous ne pouvez supprimer ce template email car c'est le seul de type <strong>${typeName}</strong>.`
    );
    const dialogRef = this.dialog.open(ModalComponent, confimModal);
    return dialogRef.afterClosed().pipe(takeUntil(this.unsubscribe$));
  }

  onDeleteConfirm(emailTemplateId: number): void {
    this.emailTemplateService
      .deleteEmailTemplate(emailTemplateId.toString())
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((_) => {
        this.dataItems = this.dataItems.filter(
          (email) => email.Id != emailTemplateId
        );
      });
  }
  protected getDataItems(): Observable<EmailTemplateModel[]> {
    return this.emailTemplateService.getEmailTemplatesByType();
  }

  protected activateItem(id: any): Observable<any> {
    return of(true);
  }

  protected deactivateItem(id: any): Observable<any> {
    return of(true);
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }

  onClearFilters = (): void => {
    this.onFiltersCleared.next();
  };

  exportAsExcel(): void {
    this.onExportExcelCaller.next();
  }
}
